import { ThemeAPI } from '@getnuvo/importer-react'

export const reviewEntries: ThemeAPI['reviewEntries'] = {
  duplicateButton: {
    display: 'none !important',
  },
}
